import styles from './focus-import.module.css';
import { Button, Spinner, Typography } from '@SBGSports/referee-react';
import * as React from 'react';
import { useTranslations } from 'i18n';
import { Dialog, DialogContent } from 'shared';
import { IconCancelSmall } from '@SBGSports/referee-react/icons';

interface NoPeriodsDialogProps {
    isLoading: boolean;
    setIsOpen: (isOpen: boolean) => void;
}

export const NoPeriodsDialog: React.FC<NoPeriodsDialogProps> = (props) => {
    const { isLoading, setIsOpen } = props;
    const { __ } = useTranslations();

    if (isLoading) {
        return (
            <Dialog open={isLoading} onClose={() => setIsOpen(false)}>
                <DialogContent>
                    <Spinner />
                </DialogContent>
            </Dialog>
        );
    }

    return (
        <Dialog fullWidth open={true} onClose={() => setIsOpen(false)}>
            <div className={styles['dialog-title']}>
                <Typography variant="heading-2">{__('smt_importer.requires_periods')}</Typography>
                <Button onClick={() => setIsOpen(false)} title="cancel" variant="text">
                    <IconCancelSmall />
                </Button>
            </div>
            <DialogContent>
                <div className={styles['warning-body']}>
                    <Typography variant="body-1">{__('misc.select_valid_activity')}</Typography>
                </div>
            </DialogContent>
        </Dialog>
    );
};
